<template>
  <div class="main-template">
    <v-alert
      dismissible
      dense
      v-if="errorMessage != '' && errorMessage"
      type="error"
    >
      {{ errorMessage }}
    </v-alert>
    <v-alert
      dismissible
      dense
      v-if="successMessage != '' && successMessage"
      type="success"
    >
      {{ successMessage }}
    </v-alert>
    <d-table
      :data_object="data_object"
      :getFreshData="true"
      :alwaysUpdate="true"
      :rowClick="rowClick"
      :hasSearch="true"
      tableName="Assitants"
      :editedItemTitle="editedItemTitle"
      :editRow="true"
      addButtonCaption="Add Assistant"
      :actionCommand="actionCommand"
      :link="link"
      :linkClick="linkClick"
      :onDataReceived="onDataReceived"
      ref="dTable"
    />
  </div>
</template>
<script>
import axios from "axios";
import DTable from "../components/Table";
import * as fun from "../plugins/common";
export default {
  components: { DTable },
  data() {
    return {
      data_object: {
        object_name: "chat_settings",
        all_records: true,
      },
      editedItemTitle: ["name"],
      actionCommand: [
        {
          icon: "mdi-chat",
          text: "View Assistant",
          color: "primary",
        },
      ],
      link: {
        field: "_id",
        name: "aichat",
      },
      currentFiles: [],
      errorMessage: "",
      successMessage: "",
    };
  },
  mounted() {
    var that = this;
    this.$root.$on("record_updated", (d) => {
      console.log(d);
    });
    this.actionCommand.forEach((a) => {
      a.action = this.linkClick;
    });
    this.$root.$on("appendClick", (m) => {
      if (m.key == "files") {
        var currentFiles = that.currentFiles.find((f) => {
          return f._id == m.model._id;
        });
        // if (m.model.files == currentFiles.files) {
        //   this.errorMessage = "Files are not changed";
        // } else {
        that.uploadFiles(m.model);
        // }
      }
    });
  },
  methods: {
    onDataReceived(data) {
      data.model.forEach((m) => {
        this.currentFiles.push({
          _id: m._id,
          files: m.files || "",
        });
      });
      return data;
    },
    linkClick(item) {
      item.text = item.name;
      item.link = "/#/aichat/" + item._id;
      window.open(item.link);
      // item.report_type = "html";

      // this.$root.addResentTab(item);
    },
    uploadFiles(model) {
      var files = model.files.split(",");
      var path =
        window.location.host.indexOf("localhost") != -1
          ? "C:\\eMover2022\\public\\chat_prompt\\files"
          : "C:\\inetpub\\myportal\\chat_prompt\\files";

      var fullPaths = [];
      files.forEach((f) => {
        fullPaths.push(path + "\\" + f);
      });
      var data = {
        files: fullPaths,
        model: model,
      };
      axios
        .post(this.serverURL + "/upload_assistant_files", data, {
          withCredentials: true,
        })
        .then(function(response) {
          console.log(response.data);
          model.file_ids = response.data.tool_resources;
          this.successMessage = "File(s) have been uploaded";
          // this.$refs.dTable.save(model);
        });
    },
  },
};
</script>
